<template>
  <div v-if="header" style="font-size: 14px">
    <ComponentPopup />

    <div class="bg-dark text-white text-center py-2">
      {{ header.info.bloco1 }}
    </div>
    <div
      class="text-center"
      style="background-color: #444444; font-size: 12px; color: #c0c0c0"
    >
      <div class="col-md-8 text-left">
        {{ header.info.bloco2 }}
      </div>
    </div>
  </div>
  <header id="header" class="header d-flex align-items-center sticky-top">
    <div
      v-if="header"
      class="container-fluid container-xl position-relative d-flex align-items-center"
    >
      <!-- Logo alinhado à direita -->
      <a
        href="#"
        class="logo d-flex align-items-center me-auto"
        @click="openHome()"
      >
        <img v-if="header.logo" :src="header.logo.url" />
        <img src="../assets/img/nbr15906.png" />
        <img src="../assets/img/iso9001.png" />
        <img src="../assets/img/pqta2021.png" />
        <img src="../assets/img/qualidade2024.png" />
      </a>

      <!-- Menu alinhado à esquerda -->
      <ComponentMenu class="ms-auto" />
    </div>
  </header>
</template>

<script>
import { onMounted, reactive, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { HeaderService } from "./header.service";

import ComponentMenu from "./menu.vue";
import ComponentPopup from "./popup.vue";

export default {
  name: "ComponentHeader",
  components: {
    ComponentMenu,
    ComponentPopup,
  },
  setup() {
    const $serviceHeader = new HeaderService();
    const $router = useRouter();

    const data = reactive({
      header: ref(),
    });

    onMounted(async () => {
      await findHeader();
    });

    function openHome() {
      $router.push({ name: "home" });
    }

    async function findHeader() {
      const response = await $serviceHeader.findHeader();
      data.header = response.data;
    }

    return {
      ...toRefs(data),
      openHome,
    };
  },
};
</script>
